import mutate from '@/utils/mutateWrapper'
import {
  CREATE_PRODUCT_MUTATION,
  UPDATE_PRODUCT_MUTATION,
  DELETE_PRODUCT_MUTATION
} from '../gql/product.gql'

export const createProduct = data => mutate(CREATE_PRODUCT_MUTATION, { data })

export const updateProduct = (id, data) =>
  mutate(UPDATE_PRODUCT_MUTATION, { id, data })

export const deleteProduct = id => mutate(DELETE_PRODUCT_MUTATION, { id })
